(() => {
  const init = (bar) => {
    if (bar.dataset.gsBound === 'true') return;

    const configurator = document.querySelector('.gs-configurator');
    if (!configurator) return;

    bar.dataset.gsBound = 'true';

    const meta = bar.querySelector('[data-gs-sticky-meta]');
    const price = bar.querySelector('[data-gs-sticky-price]');
    const was = bar.querySelector('[data-gs-sticky-was]');
    const button = bar.querySelector('[data-gs-sticky-button]');
    const thumb = bar.querySelector('[data-gs-sticky-image]');

    const bundle = configurator.querySelector('[data-gs-bundle]');
    const sizes = configurator.querySelector('.variations');

    const dropdowns = Array.from(
      configurator.querySelectorAll('.variations .product-form__input--dropdown select')
    );
    const confirmed = new Set();
    let duo = null;

    dropdowns.forEach((select) => {
      const confirm = () => {
        confirmed.add(select);
        render();
      };
      select.addEventListener('change', confirm);
      select.addEventListener('blur', confirm);
    });

    const dropdownsConfirmed = () =>
      dropdowns.every((select) => confirmed.has(select));

    const activeButton = () => {
      if (duo && duo.mode === 'set') return duo.button;
      const bundleForm = configurator.querySelector('[data-gs-form]:not([hidden])');
      if (bundleForm) return bundleForm.querySelector('[data-gs-submit]');
      return configurator.querySelector('.product--product-form [name="add"]');
    };

    const selectedOption = () =>
      configurator.querySelector('.gs-bundle__option.is-selected');

    const isBundle = () => {
      const option = selectedOption();
      return option ? option.dataset.gsMode === 'set' : false;
    };

    const render = () => {
      const option = selectedOption();
      const target = activeButton();
      const ready = target && !target.disabled && dropdownsConfirmed();

      if (duo) {
        if (meta) {
          meta.textContent = duo.mode === 'set' ? duo.title : bar.dataset.title || '';
        }
        if (price) price.textContent = duo.price;
        if (was) {
          was.textContent = duo.was || '';
          was.hidden = !duo.was;
        }
      } else if (option) {
        const optionPrice = option.querySelector('.gs-bundle__price');
        const optionWas = option.querySelector('.gs-bundle__was');
        const optionImage = option.querySelector('.gs-bundle__thumb');

        if (meta) {
          const parts = [bar.dataset.title || ''];
          if (isBundle()) {
            const askLabel = configurator.querySelector(
              '.gs-bundle__field:last-child .gs-bundle__field-label'
            );
            if (askLabel) parts.push('+ ' + askLabel.textContent.trim());
          }
          meta.textContent = parts.filter(Boolean).join(' ');
        }

        if (price && optionPrice) price.textContent = optionPrice.textContent.trim();

        if (was) {
          if (optionWas && !optionWas.hidden) {
            was.textContent = optionWas.textContent.trim();
            was.hidden = false;
          } else {
            was.hidden = true;
          }
        }

        if (thumb && optionImage && optionImage.src) {
          thumb.src = optionImage.src;
          thumb.srcset = optionImage.srcset || '';
        }
      }

      if (button) {
        button.textContent = ready
          ? bar.dataset.labelAdd
          : bar.dataset.labelChoose;
      }
    };

    if (button) {
      button.addEventListener('click', () => {
        const target = activeButton();

        if (target && !target.disabled && dropdownsConfirmed()) {
          target.click();
          return;
        }

        configurator.scrollIntoView({ behavior: 'smooth', block: 'center' });

        if (sizes) {
          sizes.classList.add('gs-highlight');
          setTimeout(() => sizes.classList.remove('gs-highlight'), 1400);
        }
      });
    }

    document.addEventListener('gs:duo:change', (event) => {
      duo = event.detail;
      render();
    });

    configurator.addEventListener('change', render);
    configurator.addEventListener('click', () => setTimeout(render, 0));
    if (bundle) new MutationObserver(render).observe(bundle, {
      subtree: true,
      childList: true,
      characterData: true,
      attributes: true
    });

    const anchor =
      configurator.querySelector('.product--product-form') || configurator;

    const observer = new IntersectionObserver(
      ([entry]) => {
        bar.hidden = entry.isIntersecting;
      },
      { threshold: 0 }
    );
    observer.observe(anchor);

    render();
  };

  const initAll = () =>
    document.querySelectorAll('[data-gs-sticky]').forEach(init);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();